import React from 'react';
import { Lock, Download } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function FinalCTA() {
  return <section id="final-cta" className="bg-navy py-24 sm:py-32 relative overflow-hidden" data-id="element-64">
      {/* Decorative background circles */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-navy-light/20 rounded-full blur-3xl pointer-events-none" data-id="element-65" />

      <div className="mx-auto max-w-7xl px-6 lg:px-8 relative z-10" data-id="element-66">
        <div className="mx-auto max-w-3xl text-center" data-id="element-67">
          <FadeIn data-id="element-68">
            <h2 className="font-serif text-4xl font-bold tracking-tight text-white sm:text-5xl mb-6" data-id="element-69">
              Reclaim Your Evening Peace
            </h2>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-70">
            <p className="text-xl text-teal-light/90 mb-10" data-id="element-71">
              For less than the cost of a takeout pizza. Get the full
              Screen-Free Sanity Playbook today and start your first 2-minute
              activity tonight.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-72">
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-3xl p-8 sm:p-12 max-w-xl mx-auto" data-id="element-73">
              <div className="flex justify-center mb-6" data-id="element-74">
                <img src="https://cdn.magicpatterns.com/uploads/uaC5hzDsh1R6gviE2cEvcn/The_Screen-Free_Peace_Playbook_IMAGE.png" alt="The Screen-Free Sanity Playbook" className="w-48 rounded-xl shadow-2xl transform -rotate-2" data-id="element-75" />
              </div>

              <div className="mb-8" data-id="element-76">
                <span className="text-white/60 uppercase tracking-wider text-sm font-semibold block mb-2" data-id="element-77">
                  Digital Download
                </span>
                <div className="flex items-center justify-center gap-4" data-id="element-78">
                  <span className="text-5xl font-serif font-bold text-white/40 line-through decoration-2" data-id="element-79">
                    $19
                  </span>
                  <span className="text-5xl font-serif font-bold text-amber" data-id="element-80">
                    Only $6.36
                  </span>
                </div>
              </div>

              <a href="https://www.plenavital.com/cart/48182360637665:1" target="_blank" rel="noopener noreferrer" onClick={() => {
              if (window.fbq) {
                window.fbq('track', 'AddToCart', {
                  content_name: 'The Screen-Free Sanity Playbook',
                  content_type: 'product',
                  value: 6.36,
                  currency: 'USD'
                });
              }
            }} className="w-full inline-flex justify-center items-center gap-2 rounded-full bg-amber px-8 py-5 text-xl font-bold text-white shadow-lg transition-all hover:bg-amber-hover hover:scale-[1.02] active:scale-[0.98] mb-6" data-id="element-81">
                GET THE PLAYBOOK NOW
              </a>

              <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-white/60" data-id="element-82">
                <div className="flex items-center gap-1.5" data-id="element-83">
                  <Lock className="h-4 w-4" data-id="element-84" />
                  <span data-id="element-85">Secure Checkout</span>
                </div>
                <span className="hidden sm:inline" data-id="element-86">•</span>
                <div className="flex items-center gap-1.5" data-id="element-87">
                  <Download className="h-4 w-4" data-id="element-88" />
                  <span data-id="element-89">Instant PDF Access</span>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}